/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Language_DescriptionInputs */

const he_profile_language_description = /** @type {(inputs: Profile_Language_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו את השפה המועדפת עליכם.`)
};

const en_profile_language_description = /** @type {(inputs: Profile_Language_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your preferred language.`)
};

/**
* | output |
* | --- |
* | "Choose your preferred language." |
*
* @param {Profile_Language_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_language_description = /** @type {((inputs?: Profile_Language_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Language_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_language_description(inputs)
	return en_profile_language_description(inputs)
});